// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__36MzT","inputWrap":"CustomTip_inputWrap__1Krm3"};